<div class="d-flex px-md-5 px-2 justify-content-center sc-settings">
  <div class="col-lg-11">

    <div class="dash-panel">
      <h3 class="dash-section-title">Personal Information</h3>
      <div class="sc-form-body">
        @if (!user.first_name) {
          <form [formGroup]="nameForm" (ngSubmit)="onSubmitNameForm()">
            <div class="row g-3 align-items-end">
              <div class="col-sm-4">
                <div class="form-group">
                  <label class="sc-field-label" for="firstName">First Name</label>
                  <input type="text" formControlName="firstName" class="form-control" [ngClass]="{ 'is-invalid': submittedNameForm && nameform.firstName.errors }" />
                  @if (submittedNameForm && nameform.firstName.errors) {
                    <div class="invalid-feedback">
                      @if (nameform.firstName.errors.required) {
                        <div>First Name is required</div>
                      }
                    </div>
                  }
                </div>
              </div>
              <div class="col-sm-4">
                <div class="form-group">
                  <label class="sc-field-label" for="lastName">Last Name</label>
                  <input type="text" formControlName="lastName" class="form-control" [ngClass]="{ 'is-invalid': submittedNameForm && nameform.lastName.errors }" />
                  @if (submittedNameForm && nameform.lastName.errors) {
                    <div class="invalid-feedback">
                      @if (nameform.lastName.errors.required) {
                        <div>Last Name is required</div>
                      }
                    </div>
                  }
                </div>
              </div>
              <div class="col-sm-4">
                <button type="submit" [disabled]="isWaitingNameReq || !nameForm.valid" class="btn btn-sm btn-primary">
                  Update
                </button>
              </div>
            </div>
          </form>
        }
        @if (user.first_name) {
          <div class="dash-row">
            <p class="dash-label">Full Name</p>
            <p class="dash-value">{{user.first_name}} {{user.last_name}}</p>
          </div>
        }
      </div>
    </div>

    <div class="dash-panel mt-4">
      <h3 class="dash-section-title">Email & Newsletter</h3>
      <div class="sc-form-body">
        @if (user.email) {
          <div class="dash-row flex-wrap">
            <p class="dash-label">Email</p>
            <div class="text-end">
              <p class="dash-value mb-1">{{user.email}}</p>
              @if (!user.has_verified_email) {
                <p class="sc-warn mb-0">Please confirm your email address</p>
              }
            </div>
          </div>

          <div class="sc-form-actions mt-3">
            @if (user.has_verified_email) {
              <button (click)="changeEmail()" type="button" class="btn btn-sm btn-primary mx-1">Update mail</button>
            }
            @if (!user.has_verified_email) {
              <button (click)="sendMailActivation()" type="button" class="btn btn-sm btn-primary mx-1">Send confirmation again</button>
            }
            @if (!user.has_verified_email) {
              <button (click)="clearUnverifiedEmail()" type="button" class="btn btn-sm btn-primary mx-1">Reset Email</button>
            }
          </div>
        }

        @if (!user.email) {
          <form [formGroup]="emailForm" (ngSubmit)="setEmail()">
            <div class="row g-3 align-items-end">
              <div class="col-sm-8">
                <div class="form-group">
                  <label class="sc-field-label" for="Email">Email</label>
                  <input type="text" formControlName="email" class="form-control" [ngClass]="{ 'is-invalid': submittedEmailForm && emailform.email.errors }" />
                  @if (submittedEmailForm && emailform.email.errors) {
                    <div class="invalid-feedback">
                      @if (emailform.email.errors.required) {
                        <p class="mb-0">Email is required</p>
                      }
                      @if (emailform.email.errors.pattern) {
                        <p class="mb-0">Email is invalid</p>
                      }
                    </div>
                  }
                </div>
              </div>
              <div class="col-sm-4">
                <button type="submit" [disabled]="isWaitingSetMailReq || !emailForm.valid" class="btn btn-sm btn-primary">Set mail</button>
              </div>
            </div>
          </form>
        }

        <hr>

        <div class="form-check form-switch sc-switch">
          <input [disabled]="isWaitingMailReq" class="form-check-input" (change)="onNewsletterToggle($event);" [checked]="user.has_subscribed_to_newsletter" type="checkbox" id="flexSwitchCheckChecked">
          <label class="form-check-label" for="flexSwitchCheckChecked">Subscribe to Newsletter</label>
        </div>
      </div>
    </div>

  </div>
</div>
